export const experienceData = [
    {
        id: 1,
        company: 'Amazon',
        jobtitle: 'Software Developer Intern',
        startYear: 'January 2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Crio.Do',
        jobtitle: 'DSA TA',
        startYear: 'July 2022',
        endYear: 'Present'
    },
    {
        id: 3,
        company: 'CodeSpeedy Technology Private Limited',
        jobtitle: 'C++ Programming Intern',
        startYear: 'Jan 2022',
        endYear: 'March 2022'
    },

]